import { isScriptLoaded, isDesktop } from "../utils";

// declare the script
let videoFrameScript = "https://player-v12.freecaster.com/freecaster/stable/fcplayer.js";

// initialize all video selectors
const playerList = document.querySelectorAll("[data-video-id]");

/**
 * @function initFrame
 * @description This function initializes the video frame
 */
const initFrame = () => {

    if (playerList.length && !isScriptLoaded(videoFrameScript)) {
        // get the script from the preferences attribute from BM
        // default value in preferences is: https://player-v12.freecaster.com/freecaster/stable/fcplayer.js
        if (playerList[0].hasAttribute("data-video-script")) {
            videoFrameScript = playerList[0].getAttribute("data-video-script");
        }

        // This code loads the IFrame Player API code asynchronously.
        let tag = document.createElement("script");

        tag.src = videoFrameScript;

        const firstScriptTag = document.getElementsByTagName("script")[0];

        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // initialize the device options for each player
        for (let i = 0; i < playerList.length; i++) {
            setDeviceOptions(playerList[i]);
        }
    }
};

/**
* Sets the device options for the video widget
* @param {object} playerContainer - the player container element
*/
function setDeviceOptions(playerContainer) {
    const $playerContainer = $(playerContainer);
    const videoIdDesktop = $playerContainer.data("video-id");
    const videoIdMobile = $playerContainer.data("video-id-mobile");
    const isSameVideoId = videoIdDesktop === videoIdMobile;
    const isDesktopValue = isDesktop();

    if (!isSameVideoId) {
        if (!isDesktopValue) {
            setClasses($playerContainer, videoIdDesktop, videoIdMobile, isDesktopValue);
        }

        const interval = setInterval(function() {
            if (typeof fcplayer === "function") {
                clearInterval(interval);
                $(window).on("resize", function() {
                    const isDesktopValue = isDesktop();

                    loadNewVideoId($playerContainer, videoIdDesktop, videoIdMobile, isDesktopValue);
                });
            }
        }, 10);
    }
}

/**
* Returns the configuration of the video player based on the device type
* @param {object} $playerContainer - the jQuery object of the player container
* @param {boolean} isDesktopValue - boolean flag to determine if the device is desktop or mobile
* @returns {object} - an object containing the configuration of the video player
*/
function getConfig ($playerContainer, isDesktopValue) {
    const configDesktop = {
        autoplay: $playerContainer.data("autoplay"),
        muted: $playerContainer.data("muted"),
        loop: $playerContainer.data("loop"),
        controls: $playerContainer.data("controls"),
        stretching: $playerContainer.data("stretching"),
        dnt: $playerContainer.data("dnt"),
        width: $playerContainer.data("width"),
        height: $playerContainer.data("height"),
        multiplay: $playerContainer.data("multiplay")
    };
    const configMobile = {
        autoplay: $playerContainer.data("autoplay-mobile"),
        muted: $playerContainer.data("muted-mobile"),
        loop: $playerContainer.data("loop-mobile"),
        controls: $playerContainer.data("controls-mobile"),
        stretching: $playerContainer.data("stretching-mobile"),
        dnt: $playerContainer.data("dnt-mobile"),
        width: $playerContainer.data("width-mobile"),
        height: $playerContainer.data("height-mobile"),
        multiplay: $playerContainer.data("multiplay-mobile")
    };

    return isDesktopValue ? configDesktop : configMobile;
}

/**
* Returns the classes for the video widget based on the device type
* @param {object} $videoWidget - the jQuery object of the video widget
* @param {boolean} isDesktopValue - whether the device is desktop or mobile
* @returns {object} - an object containing the classes for the video widget
*/
function getClasses($videoWidget, isDesktopValue) {
    const desktopClasses = {
        fullHeight : $videoWidget.data("full-height"),
        frameClasses : $videoWidget.data("frame-classes"),
        textClasses : $videoWidget.data("text-classes"),
        contentPadding : $videoWidget.data("content-padding"),
        contentPosition : $videoWidget.data("content-position"),
        textPosition : $videoWidget.data("text-position")
    };
    const mobileClasses = {
        fullHeight : $videoWidget.data("full-height-mobile"),
        frameClasses : $videoWidget.data("frame-classes-mobile"),
        textClasses : $videoWidget.data("text-classes-mobile"),
        contentPadding : $videoWidget.data("content-padding-mobile"),
        contentPosition : $videoWidget.data("content-position-mobile"),
        textPosition : $videoWidget.data("text-position-mobile")
    };

    return isDesktopValue ? desktopClasses : mobileClasses;
}

/**
* Sets classes for the video widget depending on the device type
* @param {object} $playerContainer - jQuery object of the video player container
* @param {string} videoIdDesktop - video ID for desktop devices
* @param {string} videoIdMobile - video ID for mobile devices
* @param {boolean} isDesktopValue - boolean value to determine the device type
*/
function setClasses($playerContainer, videoIdDesktop, videoIdMobile, isDesktopValue) {
    const $videoWidget = $playerContainer.parent();
    const $videoWidgetContainer = $videoWidget.find(".video-widget-container");
    const $videoWidgetContent = $videoWidget.find(".video-widget-content");
    const desktopClasses = getClasses($videoWidget, true);
    const mobileClasses = getClasses($videoWidget, false);

    if (isDesktopValue) {
        $videoWidget.removeClass(mobileClasses.contentPosition);
        $videoWidget.addClass(desktopClasses.contentPosition);

        $playerContainer.attr("data-video-id", videoIdDesktop).data("video-id", videoIdDesktop);
        $playerContainer.removeClass(mobileClasses.frameClasses).removeClass(mobileClasses.fullHeight);
        $playerContainer.addClass(desktopClasses.frameClasses).addClass(desktopClasses.fullHeight);

        if ($videoWidgetContainer.length) {
            $videoWidgetContainer.removeClass(mobileClasses.textClasses).removeClass(mobileClasses.contentPadding);
            $videoWidgetContainer.addClass(desktopClasses.textClasses).addClass(desktopClasses.contentPadding);

            $videoWidgetContent.removeClass(mobileClasses.textPosition);
            $videoWidgetContent.addClass(desktopClasses.textPosition);
        }
    } else {
        $videoWidget.removeClass(desktopClasses.contentPosition);
        $videoWidget.addClass(mobileClasses.contentPosition);

        $playerContainer.attr("data-video-id", videoIdMobile).data("video-id", videoIdMobile);
        $playerContainer.removeClass(desktopClasses.frameClasses).removeClass(desktopClasses.fullHeight);
        $playerContainer.addClass(mobileClasses.frameClasses).addClass(mobileClasses.fullHeight);

        if ($videoWidgetContainer.length) {
            $videoWidgetContainer.removeClass(desktopClasses.textClasses).removeClass(desktopClasses.contentPadding);
            $videoWidgetContainer.addClass(mobileClasses.textClasses).addClass(mobileClasses.contentPadding);

            $videoWidgetContent.removeClass(desktopClasses.textPosition);
            $videoWidgetContent.addClass(mobileClasses.textPosition);
        }
    }
}

/**
* Loads a video into the player container based on the device type
* @param {object} $playerContainer - the player container element
* @param {string} videoIdDesktop - the video ID for desktop
* @param {string} videoIdMobile - the video ID for mobile
* @param {boolean} isDesktopValue - boolean value to determine if device is desktop or mobile
*/
function loadNewVideoId($playerContainer, videoIdDesktop, videoIdMobile, isDesktopValue) {
    const videoId = $playerContainer.data("video-id");
    const videoToLoad = isDesktopValue ? videoIdDesktop : videoIdMobile;

    if (videoId !== videoToLoad) {
        fcplayer().loadVideo(videoToLoad).then(res => {
            if (res === true) {
                const config = getConfig($playerContainer, isDesktopValue);

                fcplayer().setConfig(config);
                setClasses($playerContainer, videoIdDesktop, videoIdMobile, isDesktopValue);
            }
        });
    }
}

// initialize the video frame on page load
export default function () {
    initFrame();
}
